"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HamburgerNavItem = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
require("./hamburger-nav.css");
var _excluded = ["active", "subNavItems", "addRule", "tagName", "closeHamburgerNav", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-unused-vars */
var HamburgerNavItem = exports.HamburgerNavItem = function HamburgerNavItem(_ref) {
  var active = _ref.active,
    subNavItems = _ref.subNavItems,
    _ref$addRule = _ref.addRule,
    addRule = _ref$addRule === void 0 ? false : _ref$addRule,
    _ref$tagName = _ref.tagName,
    TagName = _ref$tagName === void 0 ? 'a' : _ref$tagName,
    closeHamburgerNav = _ref.closeHamburgerNav,
    onClickProp = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])({
      'sb-hamburgerNav-navItem-rule': addRule
    })
  }, /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    className: "sb-hamburgerNavItem block text-noUnderline text-left text-md px5 py3 size12of12",
    onClick: function onClick(e) {
      if (onClickProp) {
        onClickProp(e);
      }
      closeHamburgerNav();
    }
  }, otherProps)));
};
var _default = exports["default"] = HamburgerNavItem;